import React from 'react';
import { ReadingStats } from '../types';
import { BookOpen, Clock, Heart, Flame } from 'lucide-react';

interface StatsPanelProps {
  stats: ReadingStats;
}

export const StatsPanel: React.FC<StatsPanelProps> = ({ stats }) => {
  const readingMinutes = Math.round(stats.readingTimeMs / 60000);

  return (
    <div className="grid grid-cols-2 gap-3 mb-6">
      <div className="p-4 rounded-2xl bg-white/[0.04] border border-white/10">
        <div className="flex items-center gap-2 mb-2">
          <BookOpen size={14} className="text-blue-400" />
          <span className="text-[10px] font-bold uppercase tracking-wider text-white/40">Articles</span>
        </div>
        <p className="text-2xl font-black text-white">{stats.articlesViewed}</p>
      </div>

      <div className="p-4 rounded-2xl bg-white/[0.04] border border-white/10">
        <div className="flex items-center gap-2 mb-2">
          <Clock size={14} className="text-green-400" />
          <span className="text-[10px] font-bold uppercase tracking-wider text-white/40">Read Time</span>
        </div>
        <p className="text-2xl font-black text-white">
          {readingMinutes < 60 ? `${readingMinutes}m` : `${Math.floor(readingMinutes / 60)}h ${readingMinutes % 60}m`}
        </p>
      </div>

      <div className="p-4 rounded-2xl bg-white/[0.04] border border-white/10">
        <div className="flex items-center gap-2 mb-2">
          <Heart size={14} className="text-red-400" />
          <span className="text-[10px] font-bold uppercase tracking-wider text-white/40">Liked</span>
        </div>
        <p className="text-2xl font-black text-white">{stats.articlesLiked}</p>
      </div>

      <div className="p-4 rounded-2xl bg-white/[0.04] border border-white/10">
        <div className="flex items-center gap-2 mb-2">
          <Flame size={14} className="text-orange-400" />
          <span className="text-[10px] font-bold uppercase tracking-wider text-white/40">Streak</span>
        </div>
        <p className="text-2xl font-black text-white">
          {stats.currentStreak} {stats.currentStreak === 1 ? 'day' : 'days'}
        </p>
      </div>
    </div>
  );
};
